import { useFormContext } from "react-hook-form";
import { Link } from "react-router";

export default function IdentifierTab() {
  const {
    watch,
    register,
    formState,
    setValue
  } = useFormContext();
  const registeredBy = watch("registered_by");
  const registeredBySlug = watch("registered_by_slug");
  const registeredDate = watch("datetime_registered")?.slice(0, 10);
  return (
    <div className="universaleditmodal-right-content">
      <div className="universaleditmodal-right-content-text">
        <div className="universaleditmodal-right-content-text-title">
          Идентификатор
        </div>
        <div className="universaleditmodal-right-content-text-description">
          Персональная метка игрока
        </div>
      </div>
      <div className="identifierCard">
        <img
          src="/modal/Print_Identifier_Card.png"
          alt=""
          className="identifierCard_img"
        />
        <img
          src="/modal/IdentifierCard_logo.svg"
          alt=""
          className="identifierCard_logo"
        />
      </div>
      <div className="identifierCard_about">
        <div className="identifierCard_about_title">Кем зарегистрирован</div>
        {registeredBy ?
          <Link className="identifierCard_about_description" to={'/organizer/'+ registeredBySlug || '#'}>
            {registeredBy}
          </Link> :
          <div className="identifierCard_about_description">
            {"-"}
          </div>
        }
      </div>
      <div className="identifierCard_about">
        <div className="identifierCard_about_title">Дата регистрации</div>
        <div className="identifierCard_about_description">
          {registeredDate || "-"}
        </div>
      </div>
      {!registeredDate && <div className="identifierNotice">
        Посетите полигон с развёрнутым Киберштабом, подойдите к организатору
        и сообщите о необходимости выдать вам новый идентификатор для доступа
        к системе Киберштаб
      </div>}
    </div>
  );
}
